import Vue from 'vue'
import Router from 'vue-router'
import top from '@/components/top'
import about from '@/components/about'
import service from '@/components/service'
import partners from '@/components/partners'
import contact from '@/components/contact'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'top',
      component: top,
      meta: {
        title: '株式会社アルク',
        desc: 'トップ説明'
      }
    },
    {
      path: '/about/',
      name: 'about',
      component: about,
      meta: {
        title: 'アバウト | 株式会社アルク',
        desc: 'アバウト説明'
      }
    },
    {
      path: '/service/',
      name: 'service',
      component: service,
      meta: {
        title: 'サービス | 株式会社アルク',
        desc: 'サービス説明'
      }
    },
    {
      path: '/partners/',
      name: 'partners',
      component: partners,
      meta: {
        title: 'パートナーズ | 株式会社アルク',
        desc: 'パートナーズ説明'
      }
    },
    {
      path: '/contact/',
      name: 'contact',
      component: contact,
      meta: {
        title: 'コンタクト | 株式会社アルク',
        desc: 'コンタクト説明'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js